// Utility functions for verse range handling
import { bibleBooks } from './books';

/**
 * Generate range reference from start to end verse references
 * @param {string} startBook - Book ID
 * @param {number} startChapter - Start chapter number
 * @param {number} startVerse - Start verse number
 * @param {string} endBook - Book ID
 * @param {number} endChapter - End chapter number
 * @param {number} endVerse - End verse number
 * @returns {string} Formatted range reference
 */
export const generateRangeReference = (startBook, startChapter, startVerse, endBook, endChapter, endVerse) => {
  const startBookName = bibleBooks.find(b => b.id === startBook)?.name || startBook;
  const endBookName = bibleBooks.find(b => b.id === endBook)?.name || endBook;

  if (startBook === endBook && startChapter === endChapter) {
    // Same chapter
    if (startVerse === endVerse) {
      return `${startBookName} ${startChapter}:${startVerse}`;
    } else {
      return `${startBookName} ${startChapter}:${startVerse}-${endVerse}`;
    }
  } else if (startBook === endBook) {
    // Same book, different chapters
    return `${startBookName} ${startChapter}:${startVerse} - ${startBookName} ${endChapter}:${endVerse}`;
  } else {
    // Different books
    return `${startBookName} ${startChapter}:${startVerse} - ${endBookName} ${endChapter}:${endVerse}`;
  }
};
